import { $DCprimaryColor } from 'pixel-base'
import styled from 'styled-components'

const Store = styled.div`
  border-radius: 8px;
  border: 1px solid #e8eaed;
  padding: 20px 16px;
  width: 100%;
  min-height: 100px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fafafa;

  &.active {
    border-color: ${$DCprimaryColor};
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(76, 110, 245, 0.12);
    position: relative;
    z-index: 1;
    transition: all 0.2s ease;
  }
  &:hover:not(.active) {
    border-color: #d0d5dd;
    background-color: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  }
`

const StoreLabel = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #344054;
  text-align: center;
`
const PlatformChoice = styled.div<{ padding?: string }>`
  color: rgba(104, 118, 140, 0.8);
  font-size: 15px;
  line-height: 1.5;
  margin: 15px auto;
  max-width: 450px;
  font-weight: 600;
  align-self: center;
  padding: ${(props) => props.padding || '0px'};
`

const DarazSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  align-content: stretch;
  margin: 30px 0 0 0;
  border-top: 1px solid #e6e6e6;
  form {
    width: 100%;
  }
`

const InputContainer = styled.div`
  width: 40%;
  align-self: center;
`

const WebsiteDataContainer = styled.div`
  border-top: 1px solid #e6e6e6;
  padding: 20px 10%;
  ${PlatformChoice} {
    text-align: center;
  }
`
const WebsiteData = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: flex-start;
  align-content: flex-start;
  border: 1px solid #e6e6e6;
  padding: 15px;
`
const WebsiteDataTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #4c6ef5;
`
const WebsiteDataURL = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: darkgrey;
`

const FormCard = styled.div`
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e8eaed;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  padding: 28px 32px;
  width: 100%;
  /* max-width: 480px; */
`

const StoreSidebar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`

const PageHeader = styled.div`
  margin-bottom: 24px;
`

const PageTitle = styled.h1`
  font-size: 22px;
  font-weight: 600;
  color: #1a1d21;
  margin: 0 0 6px 0;
`

const PageSubtitle = styled.p`
  font-size: 14px;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
`

const InFlowContainer = styled.div`
  text-align: center;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e8eaed;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  padding: 32px 40px;
  max-width: 440px;
`

const InFlowTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #1a1d21;
  text-align: center;
  margin-bottom: 12px;
`
const InFlowDescription = styled.div`
  color: #64748b;
  font-size: 15px;
  line-height: 1.6;
  margin: 0 auto 24px;
  max-width: 380px;
  text-align: center;
`
const InFlowActions = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 12px;
`

export {
  Store,
  StoreLabel,
  StoreSidebar,
  PageHeader,
  PageTitle,
  PageSubtitle,
  FormCard,
  PlatformChoice,
  DarazSection,
  WebsiteDataContainer,
  WebsiteData,
  WebsiteDataTitle,
  WebsiteDataURL,
  InFlowContainer,
  InFlowTitle,
  InFlowDescription,
  InFlowActions,
  InputContainer,
}
